import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environment/environment';
import { EventDTO } from '../../dto/event/event.dto';
import { AuthService } from '../auth/auth.service';
import {
  EventsFilterCriteria,
  buildQueryParamsFromCriteria,
} from '../events-filter/events-filter.model';

@Injectable({ providedIn: 'root' })
export class DashboardEventsCalendarLoaderService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  loadEvents(
    criteria: EventsFilterCriteria,
    dateRange: { startDate: string; endDate: string }
  ): Observable<EventDTO[]> {
    const built = buildQueryParamsFromCriteria(criteria);
    const httpQueryParams: Record<string, string> = {};
    if (built.exclude_group_events) {
      httpQueryParams['exclude_group_events'] = built.exclude_group_events;
    }
    if (built.eventTypes?.length) {
      httpQueryParams['event_types'] = built.eventTypes.join(',');
    }
    if (built.organization_ids) {
      httpQueryParams['organization_ids'] = built.organization_ids;
    }
    if (built.educational_path_version_ids) {
      httpQueryParams['educational_path_version_ids'] =
        built.educational_path_version_ids;
    } else if (built.educational_path_ids) {
      httpQueryParams['educational_path_ids'] = built.educational_path_ids;
    }
    if (built.module_ids) {
      httpQueryParams['module_ids'] = built.module_ids;
    }
    if (built.location_guids) {
      httpQueryParams['location_guids'] = built.location_guids;
    }
    if (built.hide_full) httpQueryParams['hide_full'] = built.hide_full;
    if (built.exclude_participated) {
      httpQueryParams['exclude_participated'] = built.exclude_participated;
    }
    if (built.search) httpQueryParams['search'] = built.search;
    if (criteria.hideSubEvents) {
      httpQueryParams['exclude_sub_events'] = 'true';
    }
    httpQueryParams['startDate'] = dateRange.startDate;
    httpQueryParams['endDate'] = dateRange.endDate;

    const excludeGroup =
      httpQueryParams['exclude_group_events'] === 'true';

    return this.http
      .get<EventDTO[]>(`${environment.apiUrl}/events`, { params: httpQueryParams })
      .pipe(
        map((events) => {
          let list = Array.isArray(events) ? events : [];
          if (!this.authService.isAuthenticated) {
            list = list.filter((e) => e.event_type !== 'exercise');
            list = list.filter((e) => e.is_shown !== false);
          }
          if (excludeGroup) {
            list = list.filter(
              (e) => e.user_group_id == null || Number(e.user_group_id) <= 0
            );
          }
          return list;
        })
      );
  }
}
